import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class UserViewComponent implements OnInit {
  userId:any;
  userData:any;
  // courses:any=[];
  // batches:any=[];
  // transactionData:any;
  imageUrl=environment.apiUrls.imageUrl;


  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
    this.activatedroute.paramMap.subscribe(params => { 
      this.userId = params.get('id'); 
      console.log('userId',this.userId)
     
  });

  }

  ngOnInit(): void { 
    this.getUserById();
    // this.getTransactionByUserId()
  }
  getUserById(){
    this.apiService.getUserbyId(this.userId).subscribe((res:any)=>{
      this.userData=res.data
      console.log('user data',res)
      // for(let course of this.userData.course){
      //   this.courses.push(course)
      // }
      // this.courses=this.courses.map((course)=>course)
      // console.log('===>>',this.courses)
      // console.log('user Data',this.userData)

      // for(let batch of this.userData.batch){
      //   this.batches.push(batch)
      // }
      // this.batches=this.batches.map((batch)=>batch)
      // console.log('batch =>',this.batches)
    })
  }
  // getTransactionByUserId(){
  //   this.apiService.getTransactionUserById(this.userId).subscribe((res:any)=>{
  //     this.transactionData=res.data
  //     console.log('transaction res',this.transactionData)
  //   })
  // }
  editUser(id:any){
    console.log('id=>> ',id)
  }
}
